/**
 * Badge component based on shadcn/ui.
 */
import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-gray-200 focus:ring-offset-0',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-gray-900 text-gray-50',
        secondary: 'border-transparent bg-gray-100 text-gray-900',
        destructive: 'border-transparent bg-red-500 text-gray-50',
        outline: 'text-gray-950',
        pending: 'border-transparent bg-yellow-100 text-yellow-800',
        processing: 'border-transparent bg-blue-100 text-blue-800',
        completed: 'border-transparent bg-green-100 text-green-800',
        failed: 'border-transparent bg-red-100 text-red-800',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export { Badge, badgeVariants };
